import React from 'react';

import {SelectTypeFilter} from 'app/components/general/SelectTypeFilter';
import {StatusFilterType} from 'app/user/types';
import {gt} from 'app/utils/i18n';

type Props = {
  value: void | '' | StatusFilterType;
  onChange: (arg0: '' | StatusFilterType) => any;
};

export const DashboardFilterUserStatus = ({
  value,
  onChange,
}: Props): JSX.Element => (
  <SelectTypeFilter
    className="form-control"
    filterValue={value || ''}
    onChange={(value) => onChange(value)}
    options={[
      {
        value: '',
        text: gt('Filter by status...'),
      },
      {
        value: 'tfa_disabled',
        text: gt('Two Factor Authentication disabled'),
      },
      {
        value: 'pending_invitation',
        text: gt('Pending invitation'),
      },
      {
        value: 'invalid_email',
        text: gt('Invalid email'),
      },
      {
        value: 'no_account_access',
        text: gt('No account access'),
      },
      {
        value: 'is_guest_until',
        text: gt('Guest Account'),
      },
    ]}
  />
);
